// Tooltip.js
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import PropTypes from "prop-types";

const Tooltip = ({ id, content, children, position = "top" }) => {
  return (
    <div>
      <div data-tooltip-id={id}>
        {children}
      </div>
      <ReactTooltip
        id={id}
        place={position}
        content={content}
        className="z-50"
        style={{
          backgroundColor: "#333",
          color: "white",
          padding: "8px 12px",
          borderRadius: "4px",
          fontSize: "14px",
          maxWidth: "300px",
          zIndex: 9999
        }}
      />
    </div>
  );
};

Tooltip.propTypes = {
  id: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(["top", "right", "bottom", "left"])
};

export default Tooltip;
